import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import Footer from "../../components/Footer";
import DFNavbar from "../../components/Navbar";
import dfscanner_icon from "./../../img/dfscanner/icon.png";
import dfscanner_screen from "./../../img/dfscanner/screen.png";
import dfscanner_treetop_treecrown from "./../../img/dfscanner/treetop-treecrown.jpg";
import dfscanner_treespecies from "./../../img/dfscanner/treespecies.png";
import dfscanner_size_estimation from "./../../img/dfscanner/size-estimation.png";
import dfscanner_area_selection from "./../../img/dfscanner/area-setection.jpg";
import { ScrollToTop } from "../../components/ScrollToTop";
import { DOWNLOAD_ROUTE } from "../../consts/routes";
import { Helmet } from "react-helmet";
import i18n from "../../i18n/configs";

/**
 * DF Scanner詳細画面
 * @returns JSX.Element
 */
const DetailDfscanner = () => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet>
                <title>{t("DetailDfscanner.meta.title")}</title>
                <meta name="description" content={t("DetailDfscanner.meta.description")} />
            </Helmet>
            <ScrollToTop />
            <DFNavbar bottomPadding={true} />
            <div className="flex-grow items-center justify-center px-6 py-8 pt-20 lg:px-20">
                <div className="mx-auto max-w-screen-md px-4 md:px-8">
                    <div className="flex items-center justify-center">
                        <img className="h-20 w-20 p-3" src={dfscanner_icon} alt="dfscanner" />
                        <h1 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl ">DF Scanner</h1>
                    </div>
                </div>

                <div className="mx-auto mt-10 flex max-w-3xl items-center justify-center">
                    {i18n.language === "ja"
                        ? "「DF Scanner」詳細ページは移行しました。"
                        : "The 'DF Scanner' details page has been moved."}
                </div>
                <div className="mx-auto flex max-w-3xl items-center justify-center">
                    <a
                        href={
                            i18n.language === "ja"
                                ? "https://deepforest-tech.co.jp/df-scanner/"
                                : "https://deepforest-tech.co.jp/en/df-scanner/"
                        }
                        className="link-text mt-4 text-sm font-bold"
                    >
                        {i18n.language === "ja" ? "新しいページへ移動する" : "Go to the new page."}
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default DetailDfscanner;
